import Map from 'ol/Map';
import View from 'ol/View';
import OSM from 'ol/source/OSM';
import TileLayer from 'ol/layer/Tile';
import Cluster from 'ol/source/Cluster'
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Point from 'ol/geom/Point';
import Feature from 'ol/Feature';
import {boundingExtent} from 'ol/extent';
import {fromLonLat} from 'ol/proj';
import {
    Circle,
    Fill,
    Stroke,
    Style,
    Text,
    Icon
  } from 'ol/style.js';

const COOKIE_ACCEPTANCE = JSON.parse(localStorage.getItem('COOKIE_ACCEPTANCE'));

if (COOKIE_ACCEPTANCE !== null && COOKIE_ACCEPTANCE.value && document.getElementsByClassName("block-locationsmap").length > 0) {
    const zoom = document.querySelector(".locations-map").dataset.zoom;
    const locations = JSON.parse(WPVARS.locations);
    
    const map = new Map({
        layers: [
            new TileLayer({
                source: new OSM()
            })
        ],
        view: new View({
            zoom: zoom,
        }),
        target: 'map',
    });
    
    const vectorLayer = new VectorLayer({
        source: new VectorSource(),
		background: "transparent",
        style: new Style({
            image: new Icon({
                anchor: [0.5, 1],
                anchorXUnits: "fraction",
                anchorYUnits: "fraction",
                src: WPURLS.stylesheetDirectoryUri + '/dist/images/marker.svg',
            })
        })
    });

	const backgroundLayer = new VectorLayer({
        source: new VectorSource(),
		background: "#783BFF",
		className: "background-layer",
		style: new Style({
            image: new Icon({
                anchor: [0.5, 1],
                anchorXUnits: "fraction",
                anchorYUnits: "fraction",
                src: WPURLS.stylesheetDirectoryUri + '/dist/images/marker.svg',
            })
        })
    });	
   
    map.addLayer(backgroundLayer);
    map.addLayer(vectorLayer);
    
    for (let i = 0; i < locations.length; i++) {
        
        let location = locations[i];
        vectorLayer.getSource().addFeature(createMarker(location));
        backgroundLayer.getSource().addFeature(createMarker(location));
        
    }

    const clusterSource = new Cluster({
        distance: 20,
        minDistance: 20,
        source: vectorLayer.getSource(),
    });

    const styleCache = {};
    
    var clusters = new VectorLayer({
        source: clusterSource,
        style: function (feature) {
            const size = feature.get('features').length;
            let style = styleCache[size];
            if (!style) {
                style = new Style({
                    image: new Circle({
                        radius: (size==1) ? 0 : 10,
                        //radius: 10,
                        stroke: new Stroke({
                            color: '#fff',
                        }),
                        fill: new Fill({
                            color: '#e52250',
                        }),
                    }),
                    text: new Text({
                        text: (size==1) ? '' : size.toString(),
                        //text: size.toString(),
                        fill: new Fill({
                            color: '#fff',
                        }),
                    }),
                });
                styleCache[size] = style;
            }
            return style;
        },
    });

    map.addLayer(clusters);

    map.getView().fit(vectorLayer.getSource().getExtent(), {duration: 1000, padding: [60, 20, 20, 20]});

    if(map.getView().getZoom() > 14){
        map.getView().setZoom(14);
    }
    
    function createMarker(location) {

        return new Feature({
            geometry: new Point(fromLonLat([parseFloat(location.lng), parseFloat(location.lat)])),
            id: location.id,
            title: location.title,
            address: location.address
        });

    }

    map.on('click', (e) => {

        vectorLayer.getFeatures(e.pixel).then((clickedMarker) => {

            const locationDetails = document.getElementById('locationDetails');

            if(locationDetails) {
                const locationDetailsContent = locationDetails.querySelector('.details-content');
        
                locationDetailsContent.innerHTML = '<h4 class="location-name">' + clickedMarker[0].get('title') + '</h4>' + '<div class="location-address">' + clickedMarker[0].get('address') + '</div>';
                locationDetails.classList.add('show');
            }

        });

        clusters.getFeatures(e.pixel).then((clickedFeatures) => {
          if (clickedFeatures.length) {
            // Get clustered Coordinates
            const features = clickedFeatures[0].get('features');
            if (features.length > 1) {

                const curBoundingExtent = boundingExtent (
                    features.map((r) => r.getGeometry().getCoordinates())
                );
                
                map.getView().fit(curBoundingExtent, {duration: 1000, padding: [100, 100, 100, 100], maxZoom: 20});

            }
          }
        });
    });

    const detailsCloseBtns = document.querySelectorAll('#locationDetails .close');

    if(detailsCloseBtns.length) {

        for (var i = 0; i < detailsCloseBtns.length; i++) {
            detailsCloseBtns[i].addEventListener('click', function(e) {
                e.currentTarget.parentElement.classList.remove('show');
            });
        }

    }
    

}